/**
 * Redeem Page Voucher Modal: show the modal by adding the necessary classes.
 */
export function showVoucherModal(): void {
	const body = document.querySelector('body') as HTMLElement;
	const voucherModal = document.querySelector('.wc-voucher-modal') as HTMLElement;
	if (!body || !voucherModal) return;

	setTimeout(function () {
		if (!body.classList.contains('modal-active')) {
			body.classList.add('modal-active');
		}
		voucherModal?.classList.add('modal-active', 'modal-transition');
	}, 500);

	voucherModal.addEventListener(
		'transitionend',
		() => {
			// Shouldn't need a timeout, but I think there was an issue with the web component
			// loading with the transition simultaneously and this transitionend firing prematurely
			setTimeout(function () {
				voucherModal?.classList.remove('modal-transition');
			}, 500);
		},
		{ once: true },
	);
}
